import { ActionMenusProps } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import {
  ActionMenu,
  ButtonV2Props,
  IconTrailing,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames';
import { FC, useEffect, useMemo, useRef } from 'react';
import styles from './styles.module.scss';
import { useItems } from './useItems';

const cx = classnames.bind(styles);

export const ActionMenus: FC<ActionMenusProps> = ({
  onSendEmail,
  disabledSendmail,
  handleOpenInstructionPdfDialog,
  disabledExportPdf,
  dropDownProps,
  isDisabled,
  isLoading,
}) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const contentWidth = useRef<number | null>(null);
  const { t } = useTranslation();
  const items = useItems({
    onSendEmail,
    disabledSendmail,
    handleOpenInstructionPdfDialog,
    disabledExportPdf,
  });

  useEffect(() => {
    if (!buttonRef.current || contentWidth.current !== null) return;
    if (!contentWidth.current) {
      contentWidth.current = buttonRef.current?.clientWidth ?? null;
    }
  }, [isLoading]);

  const buttonProps: ButtonV2Props = useMemo(
    () => ({
      children: t('instruction_menu_document_instruction'),
      color: 'primary',
      isSecondary: true,
      isTertiary: false,
      rightIcon: <IconTrailing size={16} />,
      isDisabled,
      isLoading,
      ref: buttonRef,
      buttonContainerClassName: cx({
        [styles.loading]: isLoading,
      }),
      style: {
        minWidth:
          isLoading && contentWidth.current ? contentWidth.current : undefined,
      },
    }),
    [t, isDisabled, isLoading, contentWidth]
  );

  return (
    <ActionMenu
      type='button'
      items={items}
      buttonProps={buttonProps}
      dropDownProps={dropDownProps}
    />
  );
};
